import React from "react";
import { StyleSheet, View, TouchableOpacity } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import ChevronRight from "@assets/svg/ChevronRight";
import { startOfWeek } from "date-fns";

function WeekSelector({
  startDate,
  weekendDate,
  endDate,
  onPreviousWeek,
  onNextWeek,
  selectedDay,
}) {
  const isCurrentWeek = () =>
    new Date(
      startOfWeek(weekendDate, { weekStartsOn: 1 }).setDate(
        startOfWeek(weekendDate, { weekStartsOn: 1 }).getDate() + 7,
      ),
    ) >= new Date();

  const isInFourWeeks = () =>
    new Date(
      startOfWeek(weekendDate, { weekStartsOn: 1 }).setDate(
        startOfWeek(weekendDate, { weekStartsOn: 1 }).getDate() + 21,
      ),
    ) >= new Date();

  return (
    <View style={styles.container}>
      {isInFourWeeks() ? (
        <TouchableOpacity
          testID="dp-week-btn"
          onPress={onPreviousWeek}
          style={styles.arrowButton}
        >
          <ChevronRight
            style={styles.chevronRight}
            pathFill={color.mediumBlack}
          />
        </TouchableOpacity>
      ) : (
        <View style={{ width: 30 }} />
      )}
      <View style={styles.dateContainer}>
        <Text variant="body_text_2" style={styles.dateText}>
          {startDate} - {endDate}
        </Text>
      </View>
      {!isCurrentWeek() ? (
        <TouchableOpacity
          testID="dp-week-btn"
          onPress={onNextWeek}
          style={styles.arrowButton}
        >
          <ChevronRight
            style={{ height: 12, width: 12 }}
            pathFill={color.mediumBlack}
          />
        </TouchableOpacity>
      ) : (
        <View style={{ width: 30 }} />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    paddingVertical: 0,
    backgroundColor: color.white,
  },
  arrowButton: {
    padding: 8,
    borderRadius: 20,
    borderColor: color.lighterBlack,
    borderWidth: 1,
  },
  dateContainer: {
    flex: 1,
    alignItems: "center",
  },
  dateText: {
    color: color.black,
  },
  chevronRight: {
    height: 12,
    width: 12,
    transform: [{ rotate: "180deg" }],
  },
});

export default WeekSelector;
